import { Streamingpackage } from '../../../interfaces/StreamingProvider.interface';

/*
 * function to check if a price is valid, as the db contains data with -999(NOT_AVAILABLE)
 * @param {number} price (monthly or yearly in cents)
 * @returns {boolean} Price valid or not
 */
export function isValidPrice(price: number): boolean {
  return price >= 0;
}

/*
 * function to compare 2 prices of Packages
 * @param {Streamingpackage} packageA
 * @param {Streamingpackage} packageB
 * @returns {number}
 * There are six different cases
 *    1: Both have `monthly_price_cents` and `monthly_price_yearly_subscription_in_cents`
 *    2: Both have only `monthly_price_cents`
 *    3: Both have  only `monthly_price_yearly_subscription_in_cents`
 *    4: One package has only  `monthly_price_cents`
 *    5: One package has only   `monthly_price_yearly_subscription_in_cents`
 *    6: everything else
 */
export const comparePrices = (
  packageA: Streamingpackage,
  packageB: Streamingpackage
): number => {
  // Case 1
  if (
    isValidPrice(packageA.monthly_price_cents) &&
    isValidPrice(packageA.monthly_price_yearly_subscription_in_cents) &&
    isValidPrice(packageB.monthly_price_cents) &&
    isValidPrice(packageB.monthly_price_yearly_subscription_in_cents)
  ) {
    const minPriceA = Math.min(
      packageA.monthly_price_cents,
      packageA.monthly_price_yearly_subscription_in_cents
    );
    const minPriceB = Math.min(
      packageB.monthly_price_cents,
      packageB.monthly_price_yearly_subscription_in_cents
    );
    return minPriceA - minPriceB;
  }

  // Case 2
  if (
    isValidPrice(packageA.monthly_price_cents) &&
    isValidPrice(packageB.monthly_price_cents)
  ) {
    return packageA.monthly_price_cents - packageB.monthly_price_cents;
  }

  // Case 3
  if (
    isValidPrice(packageA.monthly_price_yearly_subscription_in_cents) &&
    isValidPrice(packageB.monthly_price_yearly_subscription_in_cents)
  ) {
    return (
      packageA.monthly_price_yearly_subscription_in_cents -
      packageB.monthly_price_yearly_subscription_in_cents
    );
  }

  // Case 4
  if (
    isValidPrice(packageA.monthly_price_cents) &&
    isValidPrice(packageB.monthly_price_yearly_subscription_in_cents)
  ) {
    return (
      packageA.monthly_price_cents -
      packageB.monthly_price_yearly_subscription_in_cents
    );
  }

  // Case 5
  if (
    isValidPrice(packageA.monthly_price_yearly_subscription_in_cents) &&
    isValidPrice(packageB.monthly_price_cents)
  ) {
    return (
      packageA.monthly_price_yearly_subscription_in_cents -
      packageB.monthly_price_cents
    );
  }

  //ELSE, nothing to compare
  return 0;
};
